export default "__VITE_ASSET__LkWECHiB__"